// extracted by mini-css-extract-plugin
module.exports = {"title":"Dialog_title__El5Nz","_centered":"Dialog__centered__F7VwZ","title__inner":"Dialog_title__inner__tny4a","close":"Dialog_close__8E3na"};